import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './gas-supply.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const GasSupplyDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const gasSupplyEntity = useAppSelector(state => state.gasSupply.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="gasSupplyDetailsHeading">
          <Translate contentKey="fleetSenseApp.gasSupply.detail.title">GasSupply</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{gasSupplyEntity.id}</dd>
          <dt>
            <span id="volume">
              <Translate contentKey="fleetSenseApp.gasSupply.volume">Volume</Translate>
            </span>
          </dt>
          <dd>{gasSupplyEntity.volume}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="fleetSenseApp.gasSupply.price">Price</Translate>
            </span>
          </dt>
          <dd>{gasSupplyEntity.price}</dd>
          <dt>
            <span id="distance">
              <Translate contentKey="fleetSenseApp.gasSupply.distance">Distance</Translate>
            </span>
          </dt>
          <dd>{gasSupplyEntity.distance}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.gasSupply.scheduling">Scheduling</Translate>
          </dt>
          <dd>{gasSupplyEntity.scheduling ? gasSupplyEntity.scheduling.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/gas-supply" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/gas-supply/${gasSupplyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GasSupplyDetail;
